import Icon from '../components/Icon.vue'

Icon.register({
  'glass-martini': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.1 57.6C523.3 36.3 508.3 0 478.2 0H33.8C3.8 0-11.3 36.3 9.9 57.6L224 271.6V464H168C145.9 464 128 481.9 128 504 128 508.4 131.6 512 136 512H376C380.4 512 384 508.4 384 504 384 481.9 366.1 464 344 464H288V271.6L502.1 57.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/glass-martini.js
// module id = EA32
// module chunks = 144